import React from 'react';
export function CampaignSurveyIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 9a1 1 0 011-1h4a1 1 0 110 2h-4a1 1 0 01-1-1zM13 15a1 1 0 100 2h4a1 1 0 100-2h-4zM10.293 6.28L8.386 8.189l-.679-.68a1 1 0 00-1.414 1.415l1.386 1.386a1 1 0 001.414 0l2.614-2.614a1 1 0 00-1.414-1.414zM8.386 15.188l1.907-1.907a1 1 0 011.414 1.414l-2.614 2.614a1 1 0 01-1.414 0l-1.386-1.386a1 1 0 111.414-1.415l.68.68z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 5a3 3 0 013-3h14a3 3 0 013 3v14a3 3 0 01-3 3H5a3 3 0 01-3-3V5zm3-1a1 1 0 00-1 1v14a1 1 0 001 1h14a1 1 0 001-1V5a1 1 0 00-1-1H5z"
  }));
}